import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { APPLICATION_JSON } from "../../middleware/types";
import BreadCrumbsContainer from '../BreadCrumbs/BreadCrumbsContainer';
import Helper from "../Helper";
import Loader from '../Loader/Loader';
import { Modal } from '../Modal/Modal';
import { useSelector, useDispatch } from 'react-redux';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction'
import MyAccountCommonize from '../ShoppingList/MyAccountCommonize';
import { getShoppingListDetails } from '../../middleware/getShoppingListDetails';
import { getProfileDetailsAction } from '../../middleware/getProfileDetailsAction';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { updateShoppingListDetailsAction } from '../../middleware/updateShoppingListDetailsAction'
import ImportShoppingListModal from './ImportShoppingListModal';
import CbMobileLogOut from '../ShoppingList/CbMobileLogOut';

function ShoppingListDetail({ containerObject, templateName, contentId, dataZone }) {
	const [responseListDetail, setResponseListDetail, responseListDetailRef] = useStateRef('')
	const [shoppingGiftList, setShoppingGiftList, shoppingGiftListRef] = useStateRef('')
	const [isLoading, setIsLoading] = useState(false);
	const [hasError, setHasError, setHasErrorRef] = useStateRef(false);
	const [productList, setProductList, setProductListRef] = useStateRef([]);
	const [shoppingListId, setShoppingListId] = useState();
	const [productDetailList, setProductDetailList, productDetailListRef] = useStateRef();
	const [isModalopen, setIsModalOpen] = useState(false);
	const [productErrorMsg, setProductErrorMsg, productErrorMsgRef] = useStateRef('');
	const [selectAllProduct, setSelectAllProduct] = useState(false);
	const [selectedProductIds, setSelectedProductIds] = useState()
	const [errorMessage, setErrorMessage] = useState();
	const [giftListId, setGiftListId] = useState();
	const [displayNameAccend, setDisplayNameAccend] = useState(true);
	const [catalogRefIdAccend, setCatalogRefIdAccend] = useState(true);
	const [quantityDesiredAccend, setQuantityDesiredAccend] = useState(true);
	const [priceAccend, setPriceAccend] = useState(true);
	const [addListToCartResponse, setAddListResponse, addListToCartRef] = useStateRef("");
	const [invalidProduct, setInvalidProduct, invalidProductRef] = useStateRef("");
	const history = useHistory();
	const [responseList, setResponseList, responseListRef] = useStateRef('')
	const dispatch = useDispatch();
	const [selectedValue, setSelectedValue, selectedValueRef] = useStateRef('')
	const [searchValue, setSearchValue, searchValueRef] = useStateRef('')
	const [productQty, setProductQty, productQtyRef] = useStateRef('');
	//from reducer state
	const GetCartCount = useSelector(state => state.miniCartItemCountReducer.response.payload)
	const shoppingListDetails = useSelector(state => state.getShoppingListDetails.listDetails)
	const [isPublic, setIsPublic] = useState(true);
	const [isPublished, setIsPublished] = useState(false);
	const [quickOrderErrorMsg, setQuickOrderErrorMsg, quickOrderErrorMsgRef] = useStateRef('');
	const [currentUrl, setCurrentUrl, currentUrlRef] = useStateRef('')
	const profile = useSelector(state => state.getProfileDetails.profileDetails)
	const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
	//breadcrumbs object 
	const breadCrumbs = {
		"ancestors": [
			{
				label: "My Account",
				link: "/account/landing"
			},
			{
				label: "Shopping Lists",
				link: "/account/list"
			}
		],
		productName: " "
	};



	useEffect(() => {
		var url = history.location.pathname
		var splitedUri = url.split("/")
		splitedUri && splitedUri[1] && splitedUri[2] ? setCurrentUrl(splitedUri[1] + "/" + splitedUri[2]) : "";
		if (profile) {
			console.log('currentUrl...', currentUrlRef.current);
			if (profile && profile.transient && currentUrlRef.current && currentUrlRef.current == "account/list-detail") {
				window.location.href = "/account/login"
			}
		}
	}, [profile])

	useEffect(() => {
		{
			shoppingGiftListRef.current ?
				shoppingGiftListRef.current.map((itemDetail, key) => {
					if (itemDetail.productId) {
						setProductQty((prevState) => {
							return {
								...prevState,
								[itemDetail.productId]: itemDetail.quantity
							};
						});
						console.log('productQty...', productQtyRef.current);
					}
				}) : ''
		}

	}, [shoppingGiftListRef.current])

	useEffect(() => {
		if (loaderStatus == true) {
			console.log("log in shoppingListdetails page loader true");
		} else {
			console.log("log in shoppingListdetails page loader false");
			// setIsLoading(true)
			fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details`, {
				method: 'GET'
			}).then(res => res.json())
				.then(res => {
					if (res.result == "success") {
						setIsLoading(false)
						var shoppingListDetatils = (JSON.parse(res.response)).response
						setResponseList(shoppingListDetatils)
						console.log("log in getShoppingListDetail useeffect");
						{
							// responseListRef.current ? responseListRef.current.map((item) => {
							// 	if (item.dataLayer) {
							// 		console.log('dataLayerJson..', item.dataLayer);
							// 		window.dataLayer = window.dataLayer || []
							// 		window.dataLayer.push(item.dataLayer);
							// 		console.log('dataLayer...', window.dataLayer);
							// 	}

							// }) : ''
						}
						//dispatch(updateShoppingListDetailsAction(false))
					} else {
						console.log("Error result ---->>>>", res)
					}
				})
		}


	}, [])


	function handleSuceesModalTrigger(modal) {
		if (modal) {
			getShoppingListDetail();
			var hiddenShoppingListSuccessModal = document.getElementById("importshoppingSuccesId");
			hiddenShoppingListSuccessModal.click();
		}
	}
	async function getShoppingListDetail(event) {
		console.log("log in getShoppingListDetail function");
		// setIsLoading(true)
		setErrorMessage()
		setQuickOrderErrorMsg('');
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		var shoppingListId = params.get('giftlistId')
		setShoppingListId(shoppingListId)
		if (params) {
			var actionUrl = "api/rest/cb/shopping-list/shopping-list-details";
			var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/${shoppingListId}`
			var res = await Helper.fetchCallFunction(Url, "GET", false, APPLICATION_JSON, null)
			if (res.response != null) {
				var shoppingListDetails = (JSON.parse(res.response)).response
				// console.log(shoppingListDetails && shoppingListDetails.listDetail && shoppingListDetails.listDetail.isWishlist)
				// console.log(shoppingListDetails && shoppingListDetails.listDetail && shoppingListDetails.listDetail.isPublic)
				setResponseListDetail(shoppingListDetails)
				setShoppingGiftList(shoppingListDetails && shoppingListDetails.giftItems)
				setIsLoading(false)
			} else {
				setIsLoading(false)
			}
		}
	}
	useEffect(() => {
		if (loaderStatus == true) {
			console.log("log in shoppingListdetails page loader true");
		} else {
		getShoppingListDetail()
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		if (params) {
			var giftlistId = params.get('giftlistId')
			setGiftListId(giftlistId)
		}
	}
	}, [containerObject])

	const searchListItem = async (e) => {
		handleUnselectAllCheckbox()
		var searchValue = e.target.value;
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		var giftlistId = params.get('giftlistId')
		if (params) {
			var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/search-list-item";
			var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}/searchValue=${searchValue}/${giftlistId}`
			var res = await Helper.fetchCallFunction(Url, "GET", false, "", "")
			if (res.result == "success") {
				var shoppingListDetails = (JSON.parse(res.response)).response
				setShoppingGiftList(shoppingListDetails)
			} else {
				setShoppingGiftList("")
			}
		}
	}

	async function handleQuickOrder(event) {
		event.preventDefault()
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		if (params) {
			var formData = new FormData(document.getElementById('shoppingList'))
			var quickOrderQty = formData.get("itemQty")
			if (quickOrderQty === "") {
				quickOrderQty = "1";
			}
			var quickOrderItem = formData.get("itemId")

			if (quickOrderItem && quickOrderQty) {

				const inputMap = {
					quickOrderQty: quickOrderQty,
					quickOrderItem: quickOrderItem.trim(),
					giftlistId: params.get('giftlistId'),
					quickOrderSuccessURL: "/account/list-detail",
					quickOrderErrorURL: "/account/list-detail"
				}
				var actionUrl = "api/rest/cb/cart/quick-order";
				var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
				var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))

				if (res.response != null) {
					var response = (JSON.parse(res.response));
					console.log('response?.error..', response?.error);
					if (response?.error === 'true') {
						console.log('response?.errors...', response?.errors);
						setQuickOrderErrorMsg(response?.errors[0]);
						document.getElementById('itemId').value = '';
						document.getElementById('itemQty').value = '';
					} else {
						getShoppingListDetail()
						var shoppingListDetatils = (JSON.parse(res.response)).response
						setResponseListDetail(shoppingListDetatils)
						setShoppingGiftList(responseListDetailRef.current && responseListDetailRef.current.giftItems)
						console.log('listDetailAddWishlist before ')
						let ecommerceData = {
							"event": "listDetailAddWishlist",
							"list_items": [`"${quickOrderItem.trim()}"`]

						}
						window.dataLayer = window.dataLayer || []
						if (window.dataLayer.length > 0) {
							window.dataLayer.push(ecommerceData)
						}
					}
				} else {
					//  setIsLoading(false)
					console.log("Error result ---->>>>")

				}
			}
			else {
				window.location.reload();
			}
		}
	}

	const handleIndividualChecked = (event) => {
		var selected = [];
		var tables = document.getElementById("listItems");
		var chks = tables.getElementsByClassName("product");
		for (var i = 0; i < chks.length; i++) {
			if (chks[i].checked) {
				selected.push(chks[i].id);
			} else {
				document.getElementById("listsProduct").checked = false;
			}
		}
		setSelectedProductIds(selected)
	};

	const handleSelectAllCheckbox = (event) => {
		var selected = [];
		var tables = document.getElementById("listItems");
		var chks = tables.getElementsByClassName("product");
		for (var i = 0; i < chks.length; i++) {
			if (event.target.checked) {
				chks[i].checked = true;
			} else {
				chks[i].checked = false;
			}
			if (chks[i].checked) {
				selected.push(chks[i].id);
			}
			setSelectedProductIds(selected)
		}
	};
	const handleUnselectAllCheckbox = (event) => {
		var tables = document.getElementById("listItems");
		var chks = tables.getElementsByClassName("product");
		for (var i = 0; i < chks.length; i++) {
			chks[i].checked = false;
			setSelectedProductIds("")
		}
	};

	async function handleAddProductToCart(event) {
		event.preventDefault();
		// setIsLoading(true)
		var index = 0
		var productId = event.currentTarget.getAttribute('productId');
		console.log('productId ---- ', productId)
		const selectedListsInArray = productId ? [productId] : selectedProductIds && selectedProductIds ? selectedProductIds : [];
		// if (selectedListsInArray.length > 0) {
		Helper.clearErrorMsg()
		var shoppingListDetatils = responseListDetailRef.current
		const data = {
			eventName: shoppingListDetatils.listDetail && shoppingListDetatils.listDetail.Name ? shoppingListDetatils.listDetail.Name : "",
			description: shoppingListDetatils.listDetail && shoppingListDetatils.listDetail.Description ? shoppingListDetatils.listDetail.Description : "",
			isPublic: isPublic,
			isPublished: isPublished,
			giftlistId: shoppingListId,
			itemIdsList: "",
			removeGiftitemIds: "",
			updateGiftlistItemsSuccessURL: "/checkout/cart.jsp",
			updateGiftlistItemsErrorURL: `/account/list-detail.jsp?giftlistId=${shoppingListId}`
		}
		var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/add-products-to-cart";
		var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
		var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
			data: data,
			selectedProduct: selectedListsInArray,
			giftListItems: shoppingListDetatils.giftItems
		}))
		if (res.result == "success") {
			console.log("Add-list", res.response.response.response.validproducts)
			setAddListResponse(res.response.response.response.validproducts)
			// handleSiteSpecDataLayer(res?.response?.response?.response?.validproducts)
			if (res.response.response.response.invalidProducts && res.response.response.response.invalidProducts.length > 0) {
				setInvalidProduct(res.response.response.response.invalidProducts)

			} else {
				setInvalidProduct()
			}
			//updating mini cart count
			dispatch(updateProfileDetailsAction(true, "cart"));

			// updating cart count
			var addListBtn = document.getElementById("addList");
			addListBtn.setAttribute("data-bs-toggle", "modal");
			addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
			addListBtn.click();
			document.getElementById("listsProduct").checked = false;
			setIsLoading(false)
			res.response.response.response.validproducts.map((value) => {
				productId = value.ProductId
			})
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push({ "event": "list_Detail_AddCart_Item", "list_items": [`${productId}`] })
			}
		}
		else {
			setIsLoading(false)
			setProductErrorMsg(res.errorMessage)
		}
		// } else {
		// 	setProductErrorMsg("Please choose at least one shopping list to add the items from that list to your Cart.")
		// 	setIsLoading(false)
		// }
	}

	const handleAddListToCart = (event) => {
		event.preventDefault();
		setProductErrorMsg()
		var sId = new FormData(document.getElementById('shoppingList'))
		event.preventDefault();
		setIsModalOpen(false)
		setIsLoading(false)
		setHasError(false)
		var index = 0;
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		var productIdList = []
		var prodIdsList = null;
		var productDetailsList = []
		var prodDetailsList = null;
		{
			responseListDetailRef.current && responseListDetailRef.current.giftItems.map((itemDetail, index) => {
				productIdList.push(itemDetail.productId)
				productDetailsList.push(itemDetail.productId + ":" + itemDetail.quantity)
			})
		}
		if (productIdList.length > 0) {
			prodIdsList = productIdList.join(",")
		}
		if (productDetailsList.length > 0) {
			prodDetailsList = productDetailsList.join(",")
		}
		var eventName = sId.get("eventName")
		var description = sId.get("description")
		if (params) {
			const inputMap = {
				skuIdsList: prodIdsList != null ? prodIdsList : "",
				prodIdsList: prodIdsList != null ? prodIdsList : "",
				giftlistId: params.get('giftlistId'),
				eventName: eventName,
				description: description,
				isPublic: isPublic,
				isPublished: isPublished,
				productDetails: prodDetailsList
			}
			fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details/add-list-to-cart`, {
				credentials: "include",
				method: "POST",
				headers: new Headers({
					"content-Type": "application/json",
				}),
				body: JSON.stringify(inputMap)
			}).then(res => res.json())
				.then(res => {
					if (res.result === "success") {
						setIsLoading(false)
						//updating mini cart count
						dispatch(updateProfileDetailsAction(true, "shopping"));
						setAddListResponse(res.response.response.response.validproducts)
					//	handleSiteSpecDataLayer(res?.response?.response?.response?.validproducts)
						if (res.response.response.response.invalidProducts && res.response.response.response.invalidProducts.length > 0) {
							setInvalidProduct(res.response.response.response.invalidProducts)
						} else {
							setInvalidProduct()
						}
						setIsModalOpen(true)
						var addListBtn = document.getElementById("addList");
						addListBtn.setAttribute("data-bs-toggle", "modal");
						addListBtn.setAttribute("data-bs-target", `#addProductToCartModal${index}`);
						addListBtn.click();
						var addedList = []
						res.response.response.response.validproducts.map((value) => {
							addedList.push(value.ProductId)
						})

						let listDetail = {
							"event": "list_Detail_AddCart_List",
							"list_items": addedList
						}
						console.log('listDetail ---- ', listDetail)
						window.dataLayer = window.dataLayer || []
						if (window.dataLayer.length > 0) {
							window.dataLayer.push(listDetail)
						}
					} else {
						setIsLoading(false)
						const error = res.errorMessage;
						setErrorMessage(error);
						document.getElementById("add-list-to-cart-error").classList.remove("d-none");
						document.getElementById("add-list-to-cart-error").classList.add("d-block");
					}
				})
		}
	}
	function handleSiteSpecDataLayer(validateProduct) {
		console.log("handleSiteSpecDataLayer firedddddd", validateProduct);
		let productList = []
		{
			validateProduct?.map((oneProduct) => {
				let categoryList = [];
				let category = JSON.parse(oneProduct?.dataLayer_obj)
				const categoryList1 = [category["dataLayer_obj.productSubCat1"] && category["dataLayer_obj.productSubCat1"], category["dataLayer_obj.productSubCat2"] && category["dataLayer_obj.productSubCat2"], category["dataLayer_obj.productSubCat3"] && category["dataLayer_obj.productSubCat3"], category["dataLayer_obj.productSubCat4"] && category["dataLayer_obj.productSubCat4"]];

				categoryList = categoryList1;
				const productMapDuplicate = {
					"productId": oneProduct.ProductId,
					"category": categoryList
				}
				let productMap = productMapDuplicate;
				productList.push(productMap)
			})
		}

		const page = {
			"type": "product",
			"products": productList
		}
		const SLD_payload = {
			"page": page
		}
		window.ssRecsInfo = window.ssRecsInfo || {}
		window.ssRecsInfo = SLD_payload
		window.dispatchEvent(new CustomEvent("sitespect-user-action", { 'detail': SLD_payload}))
	}

	const handleExportItems = (event) => {
		event.preventDefault();
		console.log("shoppingListId...", shoppingListId);
		Helper.clearErrorMsg()
		var actionUrl = "gateway/api/v1/account/service/export-list";
		console.log('shoppingGiftListRef.current...', shoppingGiftListRef.current);
		if (shoppingGiftListRef.current.length == 0) {
			setProductErrorMsg("Your Shopping list is empty. Not allowed to export empty Shopping list.");
		} else {
			fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
				credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-By': 'XMLHttpRequest'
				},
				body: JSON.stringify({
					listId: shoppingListId,
					formFields: "listId"
				})
			})
				.then((res) => {
					console.log('res...', res.blob);
					return res.blob();
				})
				.then((blob) => {
					console.log('blob..', blob);
					let fileName = "shoppingList";
					const href = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = href;
					link.setAttribute('download', `${fileName}.xls`);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					setProductErrorMsg("");
				})
				.catch((err) => {
					props.loaderStatusCallBackFunction(false)
					return Promise.reject({ Error: 'Something Went Wrong', err });
				})

			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push({ "event": "listDetailExport" })
			}
		}
	}

	const handleSelectedvalue = (event) => {
		setSelectedValue(event.target.value)
		history.push("/account/list-detail?giftlistId=" + selectedValueRef.current)
	}

	const handleList = (event) => {
		history.push("/account/list-detail?giftlistId=" + selectedValueRef.current)
	}

	const handleUpdateList = (event) => {
		event.preventDefault();
		setIsLoading(false)
		setHasError(false)
		var sId = new FormData(document.getElementById('shoppingList'))
		var prodIdsList = null;
		var description = sId.get("description");
		var eventName;
		if (sId.get("eventName") === '') {
			eventName = responseListDetailRef?.current?.listDetail?.Name;
		} else {
			eventName = sId.get("eventName");
		}
		var searchParam = window.location.search
		const params = new URLSearchParams(searchParam);
		if (params) {
			var updateGiftlistItemsSuccessURL = `/account/list-detail?giftlistId=${params.get('giftlistId')}`
			var updateGiftlistItemsErrorURL = `/account/list-detail?giftlistId=${params.get('giftlistId')}`
			var productIdList = []
			{
				responseListDetailRef.current.giftItems.map((itemDetail, index) => {
					sId.get(itemDetail.productId)
					productIdList.push(itemDetail.productId + ":" + sId.get(itemDetail.productId))
				})
			}
			if (productIdList.length > 0) {
				prodIdsList = productIdList.join(",")
			}
			const inputMap = {
				prodIdsList: prodIdsList ? prodIdsList : "",
				isPublic: isPublic,
				isPublished: isPublished,
				description: description,
				eventName: eventName,
				giftlistId: params.get('giftlistId'),
				updateGiftlistItemsSuccessURL: updateGiftlistItemsSuccessURL,
				updateGiftlistItemsErrorURL: updateGiftlistItemsErrorURL
			}
			fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-details/update`, {
				credentials: "include",
				method: "POST",
				headers: new Headers({
					"content-Type": "application/json",
				}),
				body: JSON.stringify(inputMap)
			}).then(res => res.json())
				.then(res => {
					if (res.result === "success") {
						document.getElementById("add-list-to-cart-error").classList.remove("d-block");
						document.getElementById("add-list-to-cart-error").classList.add("d-none");
						window.location.reload();
						//setIsLoading(true)
					} else {
						setIsLoading(false)
						const error = (res.response).message;
						setErrorMessage(error);
						document.getElementById("add-list-to-cart-error").classList.remove("d-none");
						document.getElementById("add-list-to-cart-error").classList.add("d-block");
					}
				})
			window.dataLayer = window.dataLayer || []
			if (window.dataLayer.length > 0) {
				window.dataLayer.push({ "event": "listDetailUpdate" })
			}
		}

	}

	function handleQuantityChange(event, productId) {
		var currentQty = event.currentTarget.value;
		setProductQty((prevState) => {
			return {
				...prevState,
				[productId]: currentQty
			};
		});
	}

	function handleRemoveSelectedLists(event) {
		handleRemoveProductFromList(event,)
	}

	async function handleRemoveProductFromList(event, removeType) {
		event.preventDefault()
		console.log('removeType...', removeType);
		setIsLoading(false)
		var sId = new FormData(document.getElementById('shoppingList'))
		var description = sId.get("description");
		var eventName = sId.get("eventName");
		var removeGiftlistItemsSuccessURL = `/account/list-detail?giftlistId=${shoppingListId}`
		var removeGiftlistItemsErrorURL = `/account/list-detail?giftlistId=${shoppingListId}`
		// var productId = event.currentTarget.getAttribute('productId');
		var selectedListsInArray = [];
		var productId = event.currentTarget.getAttribute('productId');
		if (removeType === 'multiple') {
			selectedListsInArray = selectedProductIds && selectedProductIds ? selectedProductIds : [];
		} else {

			selectedListsInArray = productId ? [productId] : []
		}


		if (selectedListsInArray.length > 0) {
			console.log("selectedListsInArray", selectedListsInArray)
			var productIdList = []
			var itemIdsList = []
			var prodIdsList = null;
			var giftListItemIdList = null;
			{
				responseListDetailRef.current.giftItems.map((itemDetail, index) => {
					{
						selectedListsInArray.map((selected, index) => {
							console.log("selectedListsInArray2", itemDetail)
							if (selected === itemDetail.productId) {
								productIdList.push(selected + ":" + sId.get(selected))
								itemIdsList.push(itemDetail.giftlistId)
							}
						})
					}
				})
			}

			if (productIdList.length > 0) {
				prodIdsList = productIdList.join(",")
				giftListItemIdList = itemIdsList.join(",")
			}
			if (productId != null) {
				prodIdsList = productId + ":" + sId.get(productId)
			}
			const inputMap = {
				productDetails: prodIdsList ? prodIdsList : "",
				isPublic: isPublic,
				isPublished: isPublished,
				description: description,
				eventName: eventName,
				skuIdsList: "",
				prodIdsList: "",
				giftlistId: shoppingListId,
				itemIdsList: giftListItemIdList,
				removeGiftitemIds: "",
				updateGiftlistItemsSuccessURL: removeGiftlistItemsSuccessURL,
				updateGiftlistItemsErrorURL: removeGiftlistItemsErrorURL
			}
			// setIsLoading(true)
			var actionUrl = "api/rest/cb/shopping-list/shopping-list-details/remove-products";
			var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
			var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify(inputMap))
			if (res != null) {
				setSelectedProductIds()
				getShoppingListDetail()
				window.dataLayer = window.dataLayer || []
				if (removeType === 'multiple') {
					if (window.dataLayer.length > 0) {
						window.dataLayer.push({ "event": "listDetailDelete" })
					}
				} else {
					if (window.dataLayer.length > 0) {
						window.dataLayer.push({ "event": "listDetailRemoveItem" })
					}
				}
				window.location.reload();
			}
		} else {
			setProductErrorMsg("Please choose at least one list item to delete. ")
			setIsLoading(false)
		}
	}

	const emailButtonClose = (event) => {
		document.getElementById(`share-list-error-div0`).classList.remove("d-block")
		document.getElementById(`share-list-error-div0`).classList.add("d-none")
		document.getElementById("emailIput").value = "";
		document.getElementById("notesTextArea").value = "";
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push({ "event": "list_detail_email" })
		}
	}

	const handleCopyList = () => {
		var copyListBtn = document.getElementById("addList");
		copyListBtn.setAttribute("data-bs-toggle", "modal");
		copyListBtn.setAttribute("data-bs-target", `#copyListModal${0}`);
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push({ "event": "list_detail_copy" })
		}
		copyListBtn.click();
	}

	function handleImportList(event) {
		event.preventDefault()
		// var emailListBtn = document.getElementById("importListModalId");
		// emailListBtn.setAttribute("data-bs-toggle", "modal");
		// emailListBtn.setAttribute("data-bs-target", `#importListModal`);
		window.dataLayer = window.dataLayer || []
		if (window.dataLayer.length > 0) {
			window.dataLayer.push({ "event": "list_detail_import" })
		}
		//emailListBtn.click();
	}

	const handleSortingChange = (event) => {

		document.getElementById("displayName").classList.remove("sort-up")
		document.getElementById("displayName").classList.remove("sort-down")
		document.getElementById("catalogRefId").classList.remove("sort-up")
		document.getElementById("catalogRefId").classList.remove("sort-down")
		document.getElementById("quantityDesired").classList.remove("sort-up")
		document.getElementById("quantityDesired").classList.remove("sort-down")
		document.getElementById("price").classList.remove("sort-up")
		document.getElementById("price").classList.remove("sort-down")

		var accend = true
		if (event == "displayName") {
			accend = displayNameAccend
			if (displayNameAccend == true) {
				document.getElementById("displayName").classList.remove("sort-down")
				document.getElementById("displayName").classList.add("sort-up")
			} else {
				document.getElementById("displayName").classList.remove("sort-up")
				document.getElementById("displayName").classList.add("sort-down")
			}
		} else if (event == "catalogRefId") {
			accend = catalogRefIdAccend
			if (catalogRefIdAccend == true) {
				document.getElementById("catalogRefId").classList.remove("sort-down")
				document.getElementById("catalogRefId").classList.add("sort-up")
			} else {
				document.getElementById("catalogRefId").classList.remove("sort-up")
				document.getElementById("catalogRefId").classList.add("sort-down")
			}
		} else if (event == "quantityDesired") {
			accend = quantityDesiredAccend
			if (quantityDesiredAccend == true) {
				document.getElementById("quantityDesired").classList.remove("sort-down")
				document.getElementById("quantityDesired").classList.add("sort-up")
			} else {
				document.getElementById("quantityDesired").classList.remove("sort-up")
				document.getElementById("quantityDesired").classList.add("sort-down")
			}
		} else if (event == "price") {
			accend = priceAccend
			if (priceAccend == true) {
				document.getElementById("price").classList.remove("sort-down")
				document.getElementById("price").classList.add("sort-up")
			} else {
				document.getElementById("price").classList.remove("sort-up")
				document.getElementById("price").classList.add("sort-down")
			}
		}
		fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/shopping-list/shopping-list-item-sort/${giftListId}/${event}/${accend}`, {
			method: 'GET',
			headers: new Headers({
				"content-Type": "application/json",
			})
		}).then(res => res.json())
			.then(res => {
				if (res.result == "success") {
					if (event == "displayName") {
						if (displayNameAccend == true) {
							setDisplayNameAccend(false)
						} else {
							setDisplayNameAccend(true)
						}
					} else if (event == "catalogRefId") {
						if (catalogRefIdAccend == true) {
							setCatalogRefIdAccend(false)
						} else {
							setCatalogRefIdAccend(true)
						}
					} else if (event == "quantityDesired") {
						if (quantityDesiredAccend == true) {
							setQuantityDesiredAccend(false)
						} else {
							setQuantityDesiredAccend(true)
						}
					} else if (event == "price") {
						if (priceAccend == true) {
							setPriceAccend(false)
						} else {
							setPriceAccend(true)
						}
					}
					if (JSON.parse(res.response)) {
						setShoppingGiftList(JSON.parse(res.response))
					}
				} else {
					console.log("Error result ---->>>>")
				}
			})
	}
	const handleIsPublic = () => {
		if (isPublic) {
			setIsPublic(false)
		} else {
			setIsPublic(true)
		}
	}
	const handleIsPublished = () => {
		if (isPublished) {
			console.log("line620")
			setIsPublished(false)
		} else {
			console.log("line623")
			setIsPublished(true)
		}
	}
	const [inputValue, setInputValue, setInputValueRef] = useStateRef()
	const handleInputChange = (event) => {
		setInputValue(event.target.value)
	}
	useEffect(() => {
		console.log("wishList", responseListDetailRef.current && responseListDetailRef.current?.listDetail && responseListDetailRef.current?.listDetail?.isWishlist)
		console.log("public", responseListDetailRef.current && responseListDetailRef.current?.listDetail && responseListDetailRef.current?.listDetail?.isPublic)

		if (responseListDetailRef.current && responseListDetailRef.current?.listDetail && responseListDetailRef.current?.listDetail?.isWishlist) {
			setIsPublished(true)
		} else {
			setIsPublished(false)
		}

		if (responseListDetailRef.current && responseListDetailRef.current.listDetail && responseListDetailRef.current.listDetail.isPublic) {
			setIsPublic(true)
		} else {
			setIsPublic(false)
		}
	}, [responseListDetailRef.current])

	function handlePrintPage() {
		window.print()
	}

	return (
		<>
			{profile && profile.userType ?
				<div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >

					<div className="row align-items-center cb-breadcrum-list gx-0">
						<div className="col-md-11 header-padding-row">
							<BreadCrumbsContainer breadCrumbs={breadCrumbs} pageType="ShoppingListDetail" />
						</div>
						<div className="col-12 col-md-1 header-padding-row d-none d-lg-block">
							<button className="btn btn-light c-print-btn text-end" type="button" onClick={handlePrintPage}>
								<i className="bi bi-printer-fill" aria-hidden="true"></i>Print
							</button>
						</div>
					</div>
					{isLoading && <Loader />}
					{responseListDetailRef.current?.listDetail != null ?

						<div className="row page-min-height gx-0 c-shopping-list-item-padding">

							{shoppingListId || addListToCartRef.current || invalidProductRef.current ?
								<Modal index={0} giftlistId={shoppingListId} props={addListToCartRef.current && addListToCartRef.current} invalidProduct={invalidProductRef.current} /> : ""}
							<div className={`${productErrorMsgRef.current && productErrorMsgRef.current ? "d-block" : "d-none"} alert alert-danger`}><p>{productErrorMsgRef.current && productErrorMsgRef.current ? productErrorMsgRef.current : ""}</p></div>
							<div id="add-list-to-cart-error" role="alert" className="alert alert-danger">{errorMessage ? errorMessage : ""}</div>
							<MyAccountCommonize />

							<div id="content" className="col-lg-9 c-shopping-list-item-col">
								{/* onSubmit={handleQuickOrder} */}
								<form id="shoppingList" data-hs-cf-bound="true">
									<div className="row my-3 my-md-3">
										<div className="col-6 col-md-6">
											<h1 className="c-account-list-heading">
												List Details
											</h1>
										</div>
										{quickOrderErrorMsgRef.current ?
											<div class="alert alert-danger d-block" role="alert" id="quick-order-error">
												<p>
													{quickOrderErrorMsgRef.current}
												</p>
											</div> : ''
										}
										<div className="col-6 col-md-6 d-lg-none">
											<CbMobileLogOut />
										</div>
										<div className="col-12 col-md-6 text-md-end text-center mt-4 mt-md-0">
											<select className="form-select c-list-details-select" onChange={handleSelectedvalue} id="listSelect">
												<option disabled="disabled">View a Different List...</option>

												{responseListRef.current ? responseListRef.current.map((item) => {

													return (<>
														{item.Name && <>
															{responseListDetailRef.current?.listDetail && responseListDetailRef.current?.listDetail.Name == item.Name ?
																<option value={item.giftlistId} selected>{item.Name}</option> :
																<option value={item.giftlistId}>{item.Name}</option>
															}
														</>
														}
													</>)
												}) : ""}
											</select>
										</div>
									</div>
									<p id="addList"></p>
									<div class="row d-block d-lg-none c-shop-details-page">
										<div class="refine-btn list-option-btn">
											<button class="btn btn-primary c-btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">List Options</button>
										</div>
										<div class="c-offcanvas offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style={{ zIndex: '1051' }}>
											<div class="offcanvas-header">
												<h2 class="c-sidepanel-heading offcanvas-title" id="offcanvasRightLabel">List Options</h2>
												<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
											</div>
											<div class="offcanvas-body">
												<div class="c-details-right-actions">
													<Link className="btn btn-secondary mb-2" onClick={handleAddListToCart}>Add List to Cart</Link>
													<button type="button" className="btn btn-secondary mb-2 modal-btn" onClick={handleCopyList}>Copy List</button>
													<button type="button" className="btn btn-secondary mb-2 modal-btn" data-bs-toggle="modal" onClick={emailButtonClose} data-bs-target={`#emailModal0`}>Email List</button>
													<Link className="btn btn-secondary mb-2" onClick={handleExportItems}>Export List</Link>
													<button type="button" id="importListModalId" className="btn btn-secondary mb-2 modal-btn" data-bs-toggle="modal" onClick={(e) => handleImportList(e)} data-bs-target="#importListModal">Import Items</button>
													<button type="submit" class="btn btn-primary mb-2" onClick={handleUpdateList}>Update List</button>
												</div>
											</div>
										</div>
									</div>
									<div className="row c-shopping-details-page">
										<div className="col-md-8">
											<div className="mb-3 row">
												<label for="staticEmail" className="col-sm-4 col-form-label">List Name: *</label>
												<div className="col-sm-8">
													<input maxlength="40" defaultValue={responseListDetailRef.current?.listDetail && responseListDetailRef.current?.listDetail?.Name ? responseListDetailRef.current.listDetail.Name : ""} name="eventName" id="eventName" type="text" className="form-control" />
												</div>
											</div>
											<div className="mb-3 row">
												<label for="staticEmail" className="col-sm-4 col-form-label">List Description:</label>
												<div className="col-sm-8"><textarea maxlength="120" name="description" id="description" className="form-control c-text-area">{responseListDetailRef.current?.listDetail && responseListDetailRef.current.listDetail?.Description ? responseListDetailRef.current.listDetail.Description : ""}</textarea>
												</div>
											</div>
											<div className="mb-3 row">
												<label for="staticEmail" className="col-sm-4 col-form-label">List Preferences:</label>
												<div className="col-sm-8">
													<div className="form-check">
														<input name="isPublic" id="isPublic" type="checkbox" onChange={handleIsPublic} className="form-check-input" checked={isPublic} />
														<label className="form-check-label" for="flexCheckDefault">	<strong>This list is public</strong>. Allow others who know your email address to view the list.
														</label>
													</div>
													<div className="form-check">
														<input name="isPublished" id="isPublished" type="checkbox" onClick={handleIsPublished} className="form-check-input" checked={isPublished} />
														<label className="form-check-label"><strong>Treat as a Wish List</strong>. View and let others view how many of each item has been purchased.
														</label>
													</div>
												</div>
											</div>
											<hr></hr>
										</div>
										<div className="col-md-4 d-none d-md-block">
											<div className="c-details-right-actions">
												<Link className="btn btn-secondary mb-2" onClick={handleAddListToCart}>Add List to Cart</Link>
												<button type="button" className="btn btn-secondary mb-2 modal-btn" onClick={handleCopyList}>Copy List</button>
												<button type="button" className="btn btn-secondary mb-2 modal-btn" data-bs-toggle="modal" onClick={emailButtonClose} data-bs-target={`#emailModal0`}>Email List</button>
												<Link className="btn btn-secondary mb-2" onClick={handleExportItems}>Export List</Link>
												<button type="button" className="btn btn-secondary mb-2 modal-btn" data-bs-toggle="modal" onClick={(e) => handleImportList(e)} data-bs-target="#importListModal">Import Items</button>
												<button type="submit" class="btn btn-primary mb-2" onClick={handleUpdateList}>Update List</button>
											</div>
										</div>
									</div>
									<div className="row c-shopping-list-page align-items-center my-3">
										<div className="col-12 col-md-9">
											<div className="row g-1">
												<label className="col-md-3 col-form-label c-shopping-list-label">Search List:</label>
												<div className="col-10 col-md-7">
													<input type="text" placeholder="Keyword or Item #" className="form-control" id="searchKeyword" onChange={searchListItem} />
												</div>

											</div>
										</div>
									</div>
									<div className="c-list-bar d-none d-md-flex">
										<div className="c-listbar-left">
											<label className="m-hide">Selected items</label>

											<input type="button" className="btn c-shop-btn" value="Add to Cart" onClick={handleAddProductToCart} />
											<input type="button" className="btn c-shop-btn" value="Remove" onClick={(event) => handleRemoveProductFromList(event, 'multiple')} />
											<p id="addProductToCart" style={{ margin: '0' }}></p>

										</div>
										<div className="c-listbar-right c-details-search">
											<label className="m-hide">Quick Order</label>
											<input type="text" id="itemId" className="form-control c-details-search-item" name="itemId" placeholder="Item #" maxlength="10" />
											<input type="text" id="itemQty" className="form-control c-details-search-qty" name="itemQty" placeholder="Qty" maxlength="3" />
											<input type="submit" id="cartButton" className="btn c-shop-btn" value="Add to List" onClick={handleQuickOrder} />
										</div>
									</div>
									<div className="row">
										<div className="col-md-12">

											<div className="c-list-table">
												<h1 className="c-mobile-list-heading d-block d-md-none">My Lists</h1>
												<ul className="c-shop-list">
													<li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
														<div className="c-list-left">
															<span className="c-shop-list-content c-shop-list-check">
																<input type="checkbox" id="listsProduct" onChange={handleSelectAllCheckbox} className="select-all-checkbox form-check-input" />
															</span>
															<span className="c-shop-list-content c-shop-list-name">Description <Link className="sort" id="displayName" onClick={() => handleSortingChange("displayName")}></Link></span>
															<span className="c-shop-list-content c-shop-list-items">Item # <Link className="sort" id="catalogRefId" onClick={() => handleSortingChange("catalogRefId")}></Link></span>
															<span className="c-shop-list-content c-shop-list-created"># Needed <Link className="sort" id="quantityDesired" onClick={() => handleSortingChange("quantityDesired")}></Link></span>
															<span className="c-shop-list-content c-shop-list-total text-end">Price <Link className="sort" id="price" onClick={() => handleSortingChange("price")}></Link></span>
														</div>
													</li>
												</ul>
											</div>

											<ul className="c-shop-list item item-list item-cart" id="listItems">
												{shoppingGiftListRef.current ?
													shoppingGiftListRef.current.map((itemDetail, index) => {
														return (<>
															<li className="c-shop-list-item c-shop-list-body item-item">
																<div className="c-list-left">
																	<span className="c-shop-list-content c-shop-list-check">
																		<input type="checkbox" onChange={() => handleIndividualChecked()} id={`${itemDetail.productId}`} className="product form-check-input" name="productCheck" />
																	</span>
																	<span className="c-shop-list-content c-shop-list-name c-shop-details-product">
																		<Link>
																			<img src={`${itemDetail.thumbnailImg}`} className="c-shop-details-img" /></Link>
																		<Link to={itemDetail && itemDetail.productUrl ? itemDetail.productUrl : ""} className="c-shop-details-title fw-bold" dangerouslySetInnerHTML={{ __html: itemDetail && itemDetail.productName ? itemDetail.productName : "" }}>
																		</Link>
																		{itemDetail && itemDetail.cautionUrl &&
																			<ul class="c-shop-list-icons">
																				<li><img src="/images/icon-warning-caution.gif" /></li>
																			</ul>}
																		{itemDetail && itemDetail.geographicUrl &&

																		
																			<ul class="c-shop-list-icons">
																				<li><img src="/images/icon-warning-geographic.gif" /></li>
																			</ul>
																		}
																	</span>
																	<span className="c-shop-list-content c-shop-list-items">
																		<span className="d-block d-md-none c-shop-mobile-label">#Items</span>
																		<strong>{itemDetail && itemDetail.productId ? itemDetail.productId : ""}</strong>
																	</span>
																	<span className="c-shop-list-content c-shop-list-items" >
																		<strong>
																			{console.log("itemDetail && itemDetail.quantity", itemDetail && itemDetail.quantity)}
																			<input className="item-qty form-control c-form-needed" type="text" value={productQtyRef.current[itemDetail.productId]} onChange={(event) => handleQuantityChange(event, itemDetail.productId)} name={itemDetail.productId} />
																		</strong>
																		<button onClick={(event) => handleRemoveProductFromList(event, 'single')} productId={`${itemDetail.productId}`} className="btn c-shop-remove">
																			<p> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-circle-fill d-none d-md-block" viewBox="0 0 16 16">
																				<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
																			</svg> </p>
																		</button>
																	</span>
																	{itemDetail && itemDetail.quantityPurchased && <span className="item-have">{itemDetail.quantityPurchased}</span>}
																	<span className="c-shop-list-content c-shop-list-total text-md-end"><strong>{itemDetail && itemDetail.itemPrice ? itemDetail.itemPrice : ""}</strong>
																		{itemDetail && itemDetail.retailPrice && <span class="c-list-retail"><i>{` Retail `}
																			<del>{itemDetail.retailPrice}</del></i></span>}
																		<span className="c-details-cart d-md-block">
																			<button productId={`${itemDetail.productId}`} onClick={handleAddProductToCart} className="btn btn-primary mt-2 mb-2 mb-md-0">Add to Cart</button>&nbsp;
																			<button productId={`${itemDetail.productId}`} className="btn c-shop-btn d-block d-md-none" onClick={handleRemoveProductFromList}>Delete</button>
																		</span>
																	</span>
																</div>
															</li>
														</>)
													}) : ""}
											</ul>
										</div>
									</div>

								</form>
							</div>

						</div>
						: ""}

				</div> : ""
			}
			<ImportShoppingListModal handleSuceesModalTrigger={handleSuceesModalTrigger} />
		</>
	)
}

export default ShoppingListDetail
